import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import ksoAcctSdk from '@account/kso-acct-sdk';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
var getInterceptorFn = function getInterceptorFn(ksoAcctSdk) {
  return function () {
    return {
      name: 'webKsoSid',
      request: function () {
        var _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
          var isServer, _config$headers, _config$headers2, _ref, notAlreadyHasPopTokenOrIsEmpty, popToken, _config$headers3;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                isServer = typeof window === 'undefined';
                if (isServer) {
                  _context.next = 15;
                  break;
                }
                if (!(config.method && config.url)) {
                  _context.next = 15;
                  break;
                }
                _context.prev = 3;
                notAlreadyHasPopTokenOrIsEmpty = !((_config$headers = config.headers) !== null && _config$headers !== void 0 && _config$headers['X-Pop-Token']) || ((_config$headers2 = config.headers) === null || _config$headers2 === void 0 ? void 0 : _config$headers2['X-Pop-Token']) === 'empty';
                _context.next = 7;
                return ksoAcctSdk.signPopToken((_ref = config.method && config.method.toUpperCase()) !== null && _ref !== void 0 ? _ref : 'GET', config.url);
              case 7:
                popToken = _context.sent;
                if (popToken && popToken !== 'empty' && notAlreadyHasPopTokenOrIsEmpty) {
                  config.headers = _objectSpread(_objectSpread({}, (_config$headers3 = config.headers) !== null && _config$headers3 !== void 0 ? _config$headers3 : {}), {}, {
                    'X-Pop-Token': popToken
                  });
                }
                _context.next = 15;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                console.error('ksoSidIntercept: ksoAcctSdk.signPopToken', _context.t0);
                fetch('https://kmon.kdocs.cn/api/relay/store/MZwWsvjDT3l/log/non_sensitive', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    'events': [{
                      'logs': [{
                        'type': 'kmon-sign_pop_token',
                        'dynamic': {
                          'url': config.url,
                          'status': 'error'
                        }
                      }]
                    }]
                  })
                });
              case 15:
                return _context.abrupt("return", config);
              case 16:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[3, 11]]);
        }));
        function request(_x) {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    };
  };
};
function webKsoSid (origin) {
  var isServer = typeof window === 'undefined';
  if (isServer) {
    this.$inject(getInterceptorFn({
      signPopToken: function signPopToken() {
        return undefined;
      }
    })(origin));
  } else {
    try {
      this.$inject(getInterceptorFn(ksoAcctSdk)(origin));
    } catch (e) {
      console.error(e, "const ksoAcctSdk = require('@account/kso-acct-sdk/lib/kso-acct-sdk.es').default");
    }
  }
}

export { webKsoSid as default, getInterceptorFn };
